export default __webpack_public_path__ + "static/media/bottom.5037b372.svg";